import React, { useEffect, useState } from "react";
import { apiClient } from "../../../services/apiService";
import OpenApiDocViewer from "./OpenAPI";

interface Version {
  versionId: string;
  uploadedBy: string;
  uploadedAt: string;
}
interface Props {
  repo: string;
  version: string;
}

const ShowDocument = ({ repo, version }: Props) => {
  const [repos, setRepos] = useState<string[]>([]);
  const [versions, setVersions] = useState<string[]>([]);
  const [selectedRepo, setSelectedRepo] = useState<string>("");
  const [selectedVersion, setSelectedVersion] = useState<string>("");
  const [openApiSpec, setOpenApiSpec] = useState<any>(null);
  useEffect(() => {
    fetchRepos();
    if (repo && version) {
      const getDoc = async () => {
        const { data } = await apiClient(
          `/api-contract/file/${repo}/versions/${version}/openapi`
        );
        setOpenApiSpec(data);
      };
      getDoc();
      setSelectedRepo(repo);
      fetchVersions(repo);
      setSelectedVersion(version);
    }
  }, []);

  const fetchRepos = async () => {
    const response = await apiClient.get("/api-contract/api-list");
    setRepos(response.data);
  };

  const fetchVersions = async (repo: string) => {
    setSelectedVersion("");
    setVersions([]);
    const { data } = await apiClient.get(`/api-contract/file/${repo}/versions`);
    const getAllVersionIds = data.versions
      .sort(
        (a: any, b: any) =>
          new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime()
      )
      .map((version: any) => version.versionId);
    setVersions(getAllVersionIds);
  };

  const fetchOpenApiSpec = async () => {
    try {
      const { data } = await apiClient(
        `/api-contract/file/${selectedRepo}/versions/${selectedVersion}/openapi`
      );
      setOpenApiSpec(data);
    } catch (error) {
      console.error("Error fetching OpenAPI spec:", error);
    }
  };

  const handleRepoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const repo = e.target.value;
    setSelectedRepo(repo);
    fetchVersions(repo);
    setSelectedVersion("");
    setOpenApiSpec(null);
  };

  const handleVersionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedVersion(e.target.value);
  };

  const handleViewDoc = () => {
    if (selectedRepo && selectedVersion) {
      fetchOpenApiSpec();
    }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Select Repository
          </label>
          <select
            id="repo"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
            value={selectedRepo}
            onChange={handleRepoChange}
          >
            <option value="">-- Choose Repo --</option>
            {repos.map((repo) => (
              <option key={repo} value={repo}>
                {repo}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Select Version
          </label>
          <select
            id="version"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
            value={selectedVersion}
            onChange={handleVersionChange}
            disabled={!selectedRepo}
          >
            <option value="">-- Choose Version --</option>
            {versions.map((version) => (
              <option key={version} value={version}>
                {version}
              </option>
            ))}
          </select>
        </div>

        <div>
          <button
            onClick={handleViewDoc}
            className="w-full bg-blue-600 text-white font-medium px-4 py-2 rounded-md shadow hover:bg-blue-700 disabled:opacity-50"
            disabled={!selectedRepo || !selectedVersion}
          >
            View Doc
          </button>
        </div>
      </div>

      {openApiSpec && (
        <div className="mt-6">
          <OpenApiDocViewer
            openApiSpec={openApiSpec}
            selectedRepo={selectedRepo}
            selectedVersion={selectedVersion}
          />
        </div>
      )}
    </div>
  );
};

export default ShowDocument;
